/**
 * The ServiceGateway API
 * The ServiceGateway provides APIs to interact with the Gintel Easy Business Communications Suite (EBCS)
 *
 * OpenAPI spec version: 1.14.31-SNAPSHOT
 * Contact: frank.paaske@gintel.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { AddSkillResponse } from '../model/addSkillResponse';
import { EditGroupMembershipResponse } from '../model/editGroupMembershipResponse';
import { EditSkillResponse } from '../model/editSkillResponse';
import { GetAgentModeResponse } from '../model/getAgentModeResponse';
import { GetAgentStateResponse } from '../model/getAgentStateResponse';
import { GetSkillsResponse } from '../model/getSkillsResponse';
import { GetUnavailableReasonsResponse } from '../model/getUnavailableReasonsResponse';
import { GroupMembership } from '../model/groupMembership';
import { LoginAgentResponse } from '../model/loginAgentResponse';
import { LogoutAgentResponse } from '../model/logoutAgentResponse';
import { RemoveSkillResponse } from '../model/removeSkillResponse';
import { Response } from '../model/response';
import { SetAgentModeResponse } from '../model/setAgentModeResponse';
import { SetAgentStateResponse } from '../model/setAgentStateResponse';
import { Skill } from '../model/skill';
import { UnavailableReason } from '../model/unavailableReason';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';
import { QueueControlServiceInterface }                            from './queueControl.serviceInterface';


@Injectable()
export class QueueControlService implements QueueControlServiceInterface {

    protected basePath = 'http://localhost:8080/ServiceGateway/rest';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * 
     * 
     * @param organization 
     * @param login 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public addSkill1(organization?: string, login?: string, body?: Skill, observe?: 'body', reportProgress?: boolean): Observable<AddSkillResponse>;
    public addSkill1(organization?: string, login?: string, body?: Skill, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<AddSkillResponse>>;
    public addSkill1(organization?: string, login?: string, body?: Skill, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<AddSkillResponse>>;
    public addSkill1(organization?: string, login?: string, body?: Skill, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {




        let headers = this.defaultHeaders;
        if (organization !== undefined && organization !== null) {
            headers = headers.set('organization', String(organization));
        }
        if (login !== undefined && login !== null) {
            headers = headers.set('login', String(login));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.put<AddSkillResponse>(`${this.basePath}/queue/skill`,
            body,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param organization 
     * @param login 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public editGroupMembership1(organization?: string, login?: string, body?: GroupMembership, observe?: 'body', reportProgress?: boolean): Observable<EditGroupMembershipResponse>;
    public editGroupMembership1(organization?: string, login?: string, body?: GroupMembership, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<EditGroupMembershipResponse>>;
    public editGroupMembership1(organization?: string, login?: string, body?: GroupMembership, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<EditGroupMembershipResponse>>;
    public editGroupMembership1(organization?: string, login?: string, body?: GroupMembership, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {




        let headers = this.defaultHeaders;
        if (organization !== undefined && organization !== null) {
            headers = headers.set('organization', String(organization));
        }
        if (login !== undefined && login !== null) {
            headers = headers.set('login', String(login));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<EditGroupMembershipResponse>(`${this.basePath}/queue/group`,
            body,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param organization 
     * @param login 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public editSkill1(organization?: string, login?: string, body?: Skill, observe?: 'body', reportProgress?: boolean): Observable<EditSkillResponse>;
    public editSkill1(organization?: string, login?: string, body?: Skill, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<EditSkillResponse>>;
    public editSkill1(organization?: string, login?: string, body?: Skill, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<EditSkillResponse>>;
    public editSkill1(organization?: string, login?: string, body?: Skill, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {




        let headers = this.defaultHeaders;
        if (organization !== undefined && organization !== null) {
            headers = headers.set('organization', String(organization));
        }
        if (login !== undefined && login !== null) {
            headers = headers.set('login', String(login));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<EditSkillResponse>(`${this.basePath}/queue/skill`,
            body,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param organization 
     * @param login 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public editUnavailableReason1(organization?: string, login?: string, body?: UnavailableReason, observe?: 'body', reportProgress?: boolean): Observable<Response>;
    public editUnavailableReason1(organization?: string, login?: string, body?: UnavailableReason, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Response>>;
    public editUnavailableReason1(organization?: string, login?: string, body?: UnavailableReason, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Response>>;
    public editUnavailableReason1(organization?: string, login?: string, body?: UnavailableReason, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {




        let headers = this.defaultHeaders;
        if (organization !== undefined && organization !== null) {
            headers = headers.set('organization', String(organization));
        }
        if (login !== undefined && login !== null) {
            headers = headers.set('login', String(login));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<Response>(`${this.basePath}/queue/reason`,
            body,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param organization 
     * @param login 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getAgentMode1(organization?: string, login?: string, observe?: 'body', reportProgress?: boolean): Observable<GetAgentModeResponse>;
    public getAgentMode1(organization?: string, login?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<GetAgentModeResponse>>;
    public getAgentMode1(organization?: string, login?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<GetAgentModeResponse>>;
    public getAgentMode1(organization?: string, login?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {



        let headers = this.defaultHeaders;
        if (organization !== undefined && organization !== null) {
            headers = headers.set('organization', String(organization));
        }
        if (login !== undefined && login !== null) {
            headers = headers.set('login', String(login));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.get<GetAgentModeResponse>(`${this.basePath}/queue/mode`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param organization 
     * @param login 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getAgentState1(organization?: string, login?: string, observe?: 'body', reportProgress?: boolean): Observable<GetAgentStateResponse>;
    public getAgentState1(organization?: string, login?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<GetAgentStateResponse>>;
    public getAgentState1(organization?: string, login?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<GetAgentStateResponse>>;
    public getAgentState1(organization?: string, login?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {



        let headers = this.defaultHeaders;
        if (organization !== undefined && organization !== null) {
            headers = headers.set('organization', String(organization));
        }
        if (login !== undefined && login !== null) {
            headers = headers.set('login', String(login));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.get<GetAgentStateResponse>(`${this.basePath}/queue/state`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param organization 
     * @param login 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getSkills1(organization?: string, login?: string, observe?: 'body', reportProgress?: boolean): Observable<GetSkillsResponse>;
    public getSkills1(organization?: string, login?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<GetSkillsResponse>>;
    public getSkills1(organization?: string, login?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<GetSkillsResponse>>;
    public getSkills1(organization?: string, login?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {



        let headers = this.defaultHeaders;
        if (organization !== undefined && organization !== null) {
            headers = headers.set('organization', String(organization));
        }
        if (login !== undefined && login !== null) {
            headers = headers.set('login', String(login));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.get<GetSkillsResponse>(`${this.basePath}/queue/skills`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param organization 
     * @param login 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getUnavailableReasons1(organization?: string, login?: string, observe?: 'body', reportProgress?: boolean): Observable<GetUnavailableReasonsResponse>;
    public getUnavailableReasons1(organization?: string, login?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<GetUnavailableReasonsResponse>>;
    public getUnavailableReasons1(organization?: string, login?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<GetUnavailableReasonsResponse>>;
    public getUnavailableReasons1(organization?: string, login?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {



        let headers = this.defaultHeaders;
        if (organization !== undefined && organization !== null) {
            headers = headers.set('organization', String(organization));
        }
        if (login !== undefined && login !== null) {
            headers = headers.set('login', String(login));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            '*/*'
        ];

        return this.httpClient.get<GetUnavailableReasonsResponse>(`${this.basePath}/queue/reasons`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param organization 
     * @param login 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public loginAgent1(organization?: string, login?: string, observe?: 'body', reportProgress?: boolean): Observable<LoginAgentResponse>;
    public loginAgent1(organization?: string, login?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<LoginAgentResponse>>;
    public loginAgent1(organization?: string, login?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<LoginAgentResponse>>;
    public loginAgent1(organization?: string, login?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {



        let headers = this.defaultHeaders;
        if (organization !== undefined && organization !== null) {
            headers = headers.set('organization', String(organization));
        }
        if (login !== undefined && login !== null) {
            headers = headers.set('login', String(login));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            '*/*'
        ];

        return this.httpClient.post<LoginAgentResponse>(`${this.basePath}/queue/login`,
            null,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param organization 
     * @param login 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public logoutAgent1(organization?: string, login?: string, observe?: 'body', reportProgress?: boolean): Observable<LogoutAgentResponse>;
    public logoutAgent1(organization?: string, login?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<LogoutAgentResponse>>;
    public logoutAgent1(organization?: string, login?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<LogoutAgentResponse>>;
    public logoutAgent1(organization?: string, login?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {



        let headers = this.defaultHeaders;
        if (organization !== undefined && organization !== null) {
            headers = headers.set('organization', String(organization));
        }
        if (login !== undefined && login !== null) {
            headers = headers.set('login', String(login));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            '*/*'
        ];

        return this.httpClient.post<LogoutAgentResponse>(`${this.basePath}/queue/logout`,
            null,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param organization 
     * @param login 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public removeSkill1(organization?: string, login?: string, body?: Skill, observe?: 'body', reportProgress?: boolean): Observable<RemoveSkillResponse>;
    public removeSkill1(organization?: string, login?: string, body?: Skill, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<RemoveSkillResponse>>;
    public removeSkill1(organization?: string, login?: string, body?: Skill, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<RemoveSkillResponse>>;
    public removeSkill1(organization?: string, login?: string, body?: Skill, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {




        let headers = this.defaultHeaders;
        if (organization !== undefined && organization !== null) {
            headers = headers.set('organization', String(organization));
        }
        if (login !== undefined && login !== null) {
            headers = headers.set('login', String(login));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
          'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
          headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.delete<RemoveSkillResponse>(`${this.basePath}/queue/skill`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            } as any
        );
    }

    /**
     * 
     * 
     * @param organization 
     * @param login 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public removeUnavailableReason1(organization?: string, login?: string, body?: UnavailableReason, observe?: 'body', reportProgress?: boolean): Observable<Response>;
    public removeUnavailableReason1(organization?: string, login?: string, body?: UnavailableReason, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Response>>;
    public removeUnavailableReason1(organization?: string, login?: string, body?: UnavailableReason, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Response>>;
    public removeUnavailableReason1(organization?: string, login?: string, body?: UnavailableReason, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {




        let headers = this.defaultHeaders;
        if (organization !== undefined && organization !== null) {
            headers = headers.set('organization', String(organization));
        }
        if (login !== undefined && login !== null) {
            headers = headers.set('login', String(login));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.delete<Response>(`${this.basePath}/queue/reason`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            } as any
        );
    }

    /**
     * 
     * 
     * @param id 
     * @param organization 
     * @param login 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public removeUnavailableReasonWithId1(id: number, organization?: string, login?: string, observe?: 'body', reportProgress?: boolean): Observable<Response>;
    public removeUnavailableReasonWithId1(id: number, organization?: string, login?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Response>>;
    public removeUnavailableReasonWithId1(id: number, organization?: string, login?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Response>>;
    public removeUnavailableReasonWithId1(id: number, organization?: string, login?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling removeUnavailableReasonWithId1.');
        }



        let headers = this.defaultHeaders;
        if (organization !== undefined && organization !== null) {
            headers = headers.set('organization', String(organization));
        }
        if (login !== undefined && login !== null) {
            headers = headers.set('login', String(login));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            '*/*'
        ];

        return this.httpClient.delete<Response>(`${this.basePath}/queue/reason/${encodeURIComponent(String(id))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param newMode 
     * @param organization 
     * @param login 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public setAgentMode1(newMode: number, organization?: string, login?: string, observe?: 'body', reportProgress?: boolean): Observable<SetAgentModeResponse>;
    public setAgentMode1(newMode: number, organization?: string, login?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<SetAgentModeResponse>>;
    public setAgentMode1(newMode: number, organization?: string, login?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<SetAgentModeResponse>>;
    public setAgentMode1(newMode: number, organization?: string, login?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (newMode === null || newMode === undefined) {
            throw new Error('Required parameter newMode was null or undefined when calling setAgentMode1.');
        }



        let headers = this.defaultHeaders;
        if (organization !== undefined && organization !== null) {
            headers = headers.set('organization', String(organization));
        }
        if (login !== undefined && login !== null) {
            headers = headers.set('login', String(login));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            '*/*'
        ];

        return this.httpClient.post<SetAgentModeResponse>(`${this.basePath}/queue/mode/${encodeURIComponent(String(newMode))}`,
            null,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param state 
     * @param organization 
     * @param login 
     * @param subState 
     * @param pendingState 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public setAgentState1(state: number, organization?: string, login?: string, subState?: number, pendingState?: number, observe?: 'body', reportProgress?: boolean): Observable<SetAgentStateResponse>;
    public setAgentState1(state: number, organization?: string, login?: string, subState?: number, pendingState?: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<SetAgentStateResponse>>;
    public setAgentState1(state: number, organization?: string, login?: string, subState?: number, pendingState?: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<SetAgentStateResponse>>;
    public setAgentState1(state: number, organization?: string, login?: string, subState?: number, pendingState?: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (state === null || state === undefined) {
            throw new Error('Required parameter state was null or undefined when calling setAgentState1.');
        }





        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (subState !== undefined && subState !== null) {
            queryParameters = queryParameters.set('subState', <any>subState);
        }
        if (pendingState !== undefined && pendingState !== null) {
            queryParameters = queryParameters.set('pendingState', <any>pendingState);
        }

        let headers = this.defaultHeaders;
        if (organization !== undefined && organization !== null) {
            headers = headers.set('organization', String(organization));
        }
        if (login !== undefined && login !== null) {
            headers = headers.set('login', String(login));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            '*/*'
        ];

        return this.httpClient.post<SetAgentStateResponse>(`${this.basePath}/queue/state/${encodeURIComponent(String(state))}`,
            null,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
